import React from 'react';

import {ShopifyLocation} from "../services/ConsignmentService";

type ShopifyLocationFormattedProps = {
    location: ShopifyLocation
}

const ShopifyLocationFormatted = ({location} : ShopifyLocationFormattedProps) => {


    return (
        <>
            {location.name}<br />
            {location.addressLine1}<br />
            {location.addressLine2}
        </>
    )

};

export default ShopifyLocationFormatted;